import React, { useEffect, useState } from 'react';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
  Box,
  TextField,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { selectEndorsmentFormData, updateEndorsementFormData } from 'src/features/rfqDataSlice';

const WarrantiesExclusions = ({ policyDetails }) => {
  const dispatch = useDispatch();

  const [isEditable, setIsEditable] = useState(false);
   const endorsementFormData = useSelector(selectEndorsmentFormData);

  const [WarrantiesExclusionsData, setWarrantiesExclusionsData] = useState({
    WarrantiesExclusions: false,
    WarrantiesExclusionsValue: policyDetails?.WarrantiesExclusions,
  });

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;

    const valueFromPolicy =
      policyDetails?.WarrantiesExclusions || '';

    setIsEditable(checked);

    setWarrantiesExclusionsData({
      WarrantiesExclusions: checked,
      WarrantiesExclusionsValue:valueFromPolicy,
    });
  };

  useEffect(() => {
    dispatch(
      updateEndorsementFormData({
         ...endorsementFormData,
        warrantiesExclusions:{
            isSelected:WarrantiesExclusionsData?.WarrantiesExclusions,
            oldValue:WarrantiesExclusionsData?.WarrantiesExclusions?policyDetails?.warrantiesExclusions:'',
            newValue:''
        }  
      })
    );
  }, [WarrantiesExclusionsData, dispatch]);

  return (
    <>
    
          <Box sx={{ mb: 1,mt:2, display: 'flex', gap: 1 }}>
            <Typography
              variant="h5"
              className="heading"
              sx={{
                background: 'rgb(9 84 174)',
                color: '#fff',
                py: 1,
                fontWeight: 'bold',
                width: '100%',
                pl: 2,
              }}
            >
             Warranties / exclusions
            </Typography>
          </Box>

          <Grid container spacing={2} sx={{ pl: 2 }}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={WarrantiesExclusionsData.WarrantiesExclusions}
                    onChange={handleCheckboxChange}
                  />
                }
                label={policyDetails?.warrantiesExclusions?policyDetails?.warrantiesExclusions:'N/A'}
              />
            </Grid>

            
          </Grid>
        
      
    </>
  );
};

export default WarrantiesExclusions;
